module.exports = __webpack_public_path__ + "img/pos8-bg.51f06b76.jpg";